import React, { Fragment } from "react";

var UnstyledIcon = function UnstyledIcon(_ref) {
  var _ref$ariaHidden = _ref.ariaHidden,
      ariaHidden = _ref$ariaHidden === undefined ? "true" : _ref$ariaHidden,
      className = _ref.className;
  return React.createElement(
    Fragment,
    null,
    React.createElement("i", { className: className, "aria-hidden": ariaHidden })
  );
};

export default UnstyledIcon;